// Per-page SEO metadata for the localized PUREGLOSS site.
// Pure data (no imports) so the build-time prerender script can read it too.
export const SITE_URL = "https://puregloss.eu";
export const OG_IMAGE = `${SITE_URL}/img/og-puregloss.jpg`;

// Internal lang code -> URL code + Open Graph locale.
export const SEO_LANGS = [
  { lang: "de", url: "de", og: "de_DE", html: "de" },
  { lang: "ua", url: "uk", og: "uk_UA", html: "uk" },
  { lang: "en", url: "en", og: "en_GB", html: "en" },
  { lang: "pl", url: "pl", og: "pl_PL", html: "pl" },
  { lang: "ru", url: "ru", og: "ru_RU", html: "ru" },
];

// Indexable localized pages: key -> path after the language prefix.
export const SEO_PAGES = {
  home: "/",
  works: "/arbeiten",
  academy: "/academy",
  impressum: "/impressum",
  datenschutz: "/datenschutz",
  agb: "/agb",
  widerruf: "/widerruf",
  cookies: "/cookies",
};

export const pageKeyFromRest = (rest = "/") => {
  const clean = rest.replace(/\/+$/, "") || "/";
  return Object.keys(SEO_PAGES).find((k) => SEO_PAGES[k] === clean) || null;
};

export const absUrl = (urlCode, path) => `${SITE_URL}/${urlCode}${path === "/" ? "/" : path}`;
export const xDefaultUrl = (path) => `${SITE_URL}${path}`;

export const SEO_TEXT = {
  de: {
    home: {
      title: "PUREGLOSS — Mobile Autoaufbereitung & Polsterreinigung Euskirchen",
      description: "Mobile Fahrzeugaufbereitung und professionelle Polsterreinigung in Euskirchen, Bonn, Brühl, Wesseling, Köln & Umgebung. Kostenlose Preisbewertung innerhalb von 1 Stunde.",
    },
    works: {
      title: "Unsere Arbeiten — Vorher & Nachher | PUREGLOSS Euskirchen",
      description: "Echte Ergebnisse unserer mobilen Fahrzeugaufbereitung sowie Sofa-, Matratzen- und Polsterreinigung in Euskirchen und Umgebung — mit Vorher-Nachher-Fotos.",
    },
    academy: {
      title: "PUREGLOSS Akademie — Ausbildung mobile Fahrzeugaufbereitung",
      description: "Praxisnahes Trainingsprogramm für mobile Fahrzeugaufbereitung und Polsterreinigung — für Einsteiger und Profis aus Deutschland, Polen, der Ukraine und ganz Europa.",
    },
    legal: "Rechtliche Informationen von PUREGLOSS — mobile Fahrzeugaufbereitung & Polsterreinigung, Euskirchen.",
    notFound: { title: "Seite nicht gefunden | PUREGLOSS", heading: "Seite nicht gefunden", text: "Die angeforderte Seite existiert nicht oder wurde verschoben.", cta: "Zur Startseite" },
  },
  ua: {
    home: {
      title: "PUREGLOSS — Мобільний детейлінг авто та хімчистка меблів Euskirchen",
      description: "Мобільний детейлінг авто та професійна хімчистка диванів з виїздом: Euskirchen, Bonn, Brühl, Wesseling, Köln та околиці. Безкоштовна оцінка протягом 1 години.",
    },
    works: {
      title: "Наші роботи — до та після | PUREGLOSS Euskirchen",
      description: "Реальні результати мобільного детейлінгу авто, хімчистки диванів, матраців і м'яких меблів в Euskirchen та околицях — з фото до і після.",
    },
    academy: {
      title: "Академія PUREGLOSS — навчання мобільному детейлінгу",
      description: "Практична програма навчання мобільному детейлінгу та хімчистці меблів — для новачків і професіоналів з Німеччини, Польщі, України та всієї Європи.",
    },
    legal: "Юридична інформація PUREGLOSS — мобільний детейлінг авто та хімчистка меблів, Euskirchen.",
    notFound: { title: "Сторінку не знайдено | PUREGLOSS", heading: "Сторінку не знайдено", text: "Такої сторінки не існує або її було переміщено.", cta: "На головну" },
  },
  en: {
    home: {
      title: "PUREGLOSS — Mobile Car Detailing & Sofa Cleaning Euskirchen",
      description: "Mobile car detailing and professional sofa & upholstery cleaning in Euskirchen, Bonn, Brühl, Wesseling, Cologne and surrounding areas. Free quote within 1 hour.",
    },
    works: {
      title: "Our Work — Before & After | PUREGLOSS Euskirchen",
      description: "Real results of our mobile car detailing and sofa, mattress and upholstery cleaning in Euskirchen and the surrounding area — with before-and-after photos.",
    },
    academy: {
      title: "PUREGLOSS Academy — Mobile Detailing Training",
      description: "Hands-on training programme for mobile car detailing and upholstery cleaning — for beginners and professionals from Germany, Poland, Ukraine and across Europe.",
    },
    legal: "Legal information of PUREGLOSS — mobile car detailing & sofa cleaning, Euskirchen.",
    notFound: { title: "Page not found | PUREGLOSS", heading: "Page not found", text: "The page you requested does not exist or has been moved.", cta: "Back to homepage" },
  },
  pl: {
    home: {
      title: "PUREGLOSS — Mobilny detailing samochodowy i pranie tapicerki Euskirchen",
      description: "Mobilny detailing samochodowy oraz profesjonalne pranie kanap z dojazdem: Euskirchen, Bonn, Brühl, Wesseling, Kolonia i okolice. Bezpłatna wycena w ciągu 1 godziny.",
    },
    works: {
      title: "Nasze realizacje — przed i po | PUREGLOSS Euskirchen",
      description: "Prawdziwe efekty mobilnego detailingu samochodów oraz prania kanap, materacy i tapicerki w Euskirchen i okolicach — ze zdjęciami przed i po.",
    },
    academy: {
      title: "Akademia PUREGLOSS — szkolenie z mobilnego detailingu",
      description: "Praktyczny program szkoleniowy z mobilnego detailingu i prania tapicerki — dla początkujących i profesjonalistów z Niemiec, Polski, Ukrainy i całej Europy.",
    },
    legal: "Informacje prawne PUREGLOSS — mobilny detailing samochodowy i pranie tapicerki, Euskirchen.",
    notFound: { title: "Nie znaleziono strony | PUREGLOSS", heading: "Nie znaleziono strony", text: "Żądana strona nie istnieje lub została przeniesiona.", cta: "Strona główna" },
  },
  ru: {
    home: {
      title: "PUREGLOSS — Мобильный автодетейлинг и химчистка мебели Euskirchen",
      description: "Мобильный детейлинг автомобилей и профессиональная химчистка диванов с выездом: Euskirchen, Bonn, Brühl, Wesseling, Köln и окрестности. Бесплатная оценка в течение 1 часа.",
    },
    works: {
      title: "Наши работы — до и после | PUREGLOSS Euskirchen",
      description: "Реальные результаты мобильного детейлинга авто, химчистки диванов, матрасов и мягкой мебели в Euskirchen и окрестностях — с фото до и после.",
    },
    academy: {
      title: "Академия PUREGLOSS — обучение мобильному детейлингу",
      description: "Практическая программа обучения мобильному детейлингу и химчистке мебели — для новичков и профессионалов из Германии, Польши, Украины и всей Европы.",
    },
    legal: "Юридическая информация PUREGLOSS — мобильный автодетейлинг и химчистка мебели, Euskirchen.",
    notFound: { title: "Страница не найдена | PUREGLOSS", heading: "Страница не найдена", text: "Запрошенная страница не существует или была перемещена.", cta: "На главную" },
  },
};

const LEGAL_KEYS = ["impressum", "datenschutz", "agb", "widerruf", "cookies"];

// legalTitles: { impressum: "Impressum", ... } from translations (per language).
export const pageMeta = (lang, key, legalTitles = {}) => {
  const L = SEO_TEXT[lang] || SEO_TEXT.de;
  if (LEGAL_KEYS.includes(key)) {
    const name = legalTitles[key] || key;
    return { title: `${name} | PUREGLOSS`, description: `${name} — ${L.legal}` };
  }
  return L[key] || L.home;
};
